// extracted by mini-css-extract-plugin
export default {"thirdRow":"Third_thirdRow__SB6D7","thirdRowLeft":"Third_thirdRowLeft__Vbrd7","thirdRowRight":"Third_thirdRowRight__jVYcB","thirdRowRightBottom":"Third_thirdRowRightBottom__xAg3m"};